$(document).on('click', '#sabbath-alert .close', () => {
  document.getElementById('sabbath-alert').remove()
  document.cookie = 'hide_sabbath_banner=true; Max-Age=31536000; Path=/'
})
